"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
var lodash_1 = require("lodash");
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var Loader_1 = __importDefault(require("../../../../Button/Loader"));
var ErrorMsg_1 = __importDefault(require("../../../../Validation/ErrorMsg"));
var BlCheckbox_1 = __importDefault(require("../../../../FormComponents/BlCheckbox"));
var smsVerifySlice_1 = require("../../../../../features/smsVerify/smsVerifySlice");
var globalSlice_1 = require("../../../../../features/global/globalSlice");
var SmsVerificationModal_1 = __importDefault(require("../../../../Modals/SmsVerificationModal"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var PhoneInputRow = function (_a) {
    var _b;
    var index = _a.index, contact = _a.contact, onChange = _a.onChange, remove = _a.remove, error = _a.error;
    var DEFAULT_COUNTRY_CODE = 'am';
    var ONLY_COUNTRIES = ['am'];
    var MESSENGERS = ['viber', 'whatsapp', 'telegram'];
    var PHONE_NUMBER_LENGTH = 11;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var _c = react_1.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = react_1.useState(false), open = _d[0], setOpen = _d[1];
    var _e = react_1.useState(), selectedPhoneNumber = _e[0], setSelectedPhoneNumber = _e[1];
    var handleVerify = function (contact) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setSelectedPhoneNumber(contact);
                    setLoading(true);
                    return [4 /*yield*/, dispatch(smsVerifySlice_1.sendPhoneToVerify({ phone: contact.phone }))];
                case 1:
                    _a.sent();
                    setOpen(true);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (e_1.response.status === 400) {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('SMS_PAGE.PHONE_EXIST'),
                            appearance: 'error',
                        }));
                    }
                    else {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('SMS_PAGE.PHONE_SEND_FAILED'),
                            appearance: 'error',
                        }));
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var closeModal = function () {
        setOpen(false);
        setLoading(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SmsVerificationModal_1.default, { open: open, selectedPhoneNumber: selectedPhoneNumber, onClose: closeModal }),
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.phones_wrapper, (_b = {},
                _b[styles_module_scss_1.default.contacts_divider] = index > 0,
                _b)), key: contact.id },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.phone_input_box, contact.verified && styles_module_scss_1.default.verified) },
                    react_1.default.createElement(react_phone_input_2_1.default, { country: DEFAULT_COUNTRY_CODE, onlyCountries: ONLY_COUNTRIES, disableDropdown: true, countryCodeEditable: false, enableAreaCodes: false, value: contact.phone, masks: { am: '(..) ..-..-..' }, placeholder: '+374 (xx) xx-xx-xx', onChange: function (e, country) {
                            onChange(index, __assign(__assign({}, contact), { phone: e, code: country.dialCode }));
                        } }),
                    !lodash_1.isUndefined(contact.verified) &&
                        !contact.verified &&
                        contact.phone.length === PHONE_NUMBER_LENGTH && (react_1.default.createElement(react_1.default.Fragment, null, loading ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.loader },
                        react_1.default.createElement(Loader_1.default, null))) : (react_1.default.createElement("span", { onClick: function () {
                            return handleVerify(contact);
                        } }, t('SMS_PAGE.VERIFY'))))),
                    !lodash_1.isUndefined(contact.verified) &&
                        contact.verified &&
                        contact.phone.length === PHONE_NUMBER_LENGTH && (react_1.default.createElement("span", { className: styles_module_scss_1.default.is_verified },
                        react_1.default.createElement("i", { className: "cm-icon icon-check-mark" }),
                        t('SMS_PAGE.VERIFIED'))))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.contact_icons },
                MESSENGERS.map(function (name) {
                    return (react_1.default.createElement("div", { key: name },
                        react_1.default.createElement(BlCheckbox_1.default, { checked: contact.messengers.includes(name), onChange: function () {
                                var messengers = contact.messengers;
                                var idx = messengers.indexOf(name);
                                onChange(index, __assign(__assign({}, contact), { messengers: idx !== -1
                                        ? messengers.filter(function (m) { return m !== name; })
                                        : __spreadArray(__spreadArray([], messengers), [name]) }));
                            } }),
                        react_1.default.createElement("i", { className: "cm-icon icon-ic-" + name })));
                }),
                index > 0 ? (react_1.default.createElement("a", { href: "#", className: styles_module_scss_1.default.remove_phone, onClick: function (e) {
                        remove(e, contact.id);
                    } },
                    react_1.default.createElement("i", { className: "cm-icon icon-ic-remove" }))) : null)),
        error && react_1.default.createElement(ErrorMsg_1.default, { message: error.phone })));
};
exports.default = PhoneInputRow;
